<div class="w-full border rounded-lg" [style.height]="height">
  <iframe *ngIf="safeSrc && isPdf" [src]="safeSrc" class="w-full h-full rounded-lg" type="application/pdf"></iframe>
  <img *ngIf="safeSrc && !isPdf" [src]="safeSrc" class="w-full h-full object-contain rounded-lg" />
</div>